import { initializeApp, getApps, getApp } from "firebase/app";
import { logger } from "./logger";

let app;

if (typeof window === "undefined") {
  console.error(
    "Not initializing here. Firebase should run in the client-side environment."
  );
}

if (getApps().length === 0) {
  logger("initializing Firebase app");
  // Initialize Firebase app
  app = initializeApp({
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    // storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    // appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  });
} else {
  logger("using existing Firebase app");
  logger("app:", app);
  // Use existing app if already initialized
  app = getApp();
}

console.log("Firebase initialized:", app.name);

export const firebaseApp = app;
